// main.ts used in production
import { createApp } from "vue";
import App from "./App.vue";
import { store } from "./store";
import PrimeVue from "primevue/config";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Splitter from "primevue/splitter";
import SplitterPanel from "primevue/splitterpanel";
import Menu from "primevue/menu";
import Checkbox from "primevue/checkbox";
import ProgressSpinner from "primevue/progressspinner";
import Listbox from "primevue/listbox";
import ScrollPanel from "primevue/scrollpanel";
import Card from "primevue/card";
import Badge from "primevue/badge";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import ConfirmDialog from "primevue/confirmdialog";
import Dialog from "primevue/dialog";
import OverlayPanel from "primevue/overlaypanel";
import Fieldset from "primevue/fieldset";
import Dropdown from "primevue/dropdown";
import Textarea from "primevue/textarea";
import Message from "primevue/message";
import Toast from "primevue/toast";
import "./assets/reset.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "primevue/resources/primevue.min.css";
import "primevue/resources/themes/lara-light-blue/theme.css";
import "./assets/theme.css";
import ConfirmationService from "primevue/confirmationservice";
import ToastService from "primevue/toastservice";
import NextGenLoader from "./lib/nextGen/Loader";
import routerService from "./services/router.service";

// This provides the bootstrapping to register a component and load the component in any UI.
NextGenLoader();

// Define a loader. The loader requires `mount` and `update` methods.
class loader {
  app: any;

  constructor() {
    // We store the instance of the app here to perform updates on it later.
    this.app = null;
  }

  mount(DOMElement, config) {
    // Here we are using globalProperties for convenience. This could be swapped out to VueX is wanted.
    const app = createApp(App, config);
    app.use(ConfirmationService);
    app.use(store);
    app.use(PrimeVue);
    app.use(ToastService);
    app.component("DataTable", DataTable);
    app.component("Column", Column);
    app.component("InputText", InputText);
    app.component("Button", Button);
    app.component("Splitter", Splitter);
    app.component("SplitterPanel", SplitterPanel);
    app.component("Menu", Menu);
    app.component("Checkbox", Checkbox);
    app.component("ProgressSpinner", ProgressSpinner);
    app.component("ListBox", Listbox);
    app.component("ScrollPanel", ScrollPanel);
    app.component("Card", Card);
    app.component("Badge", Badge);
    app.component("Accordion", Accordion);
    app.component("AccordionTab", AccordionTab);
    app.component("ConfirmDialog", ConfirmDialog);
    app.component("Dialog", Dialog);
    app.component("OverlayPanel", OverlayPanel);
    app.component("FieldSet", Fieldset);
    app.component("Dropdown", Dropdown);
    app.component("Textarea", Textarea);
    app.component("Message", Message);
    app.component("Toast", Toast);
    routerService.initialise(config);
    app.use(routerService.getRouter());
    app.mount(DOMElement);
    this.app = app;
    return this.app;
  }

  update(config) {
    // This allows to update the token.
    this.app.config.globalProperties.token = config.token;
  }

  destroy() {
    // This allows to update the token.
    this.app.unmount();
  }
}

export default loader;

window["registerNextGenComponent"]("pluspay", loader);

// window["mountNextGenComponent"]("#fulfilment", {});
